/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaPartialAvailability: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="partialAvailability" viewBox="0 0 100 30">
      <rect height="30" width="100" rx="15" ry="15" fill="#4D7080"></rect>
      <rect width="5" height="30" x="21.25" y="0" fill="white"></rect>
      <rect width="5" height="30" x="47.5" y="0" fill="white"></rect>
      <rect width="5" height="30" x="73.75" y="0" fill="white"></rect>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaPartialAvailability)
